var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['MyTimeline', ( _obj = {}, _obj[("MyTimeline--" + _vm.size)] = _vm.size, _obj )]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }